"use strict";
/**
 * @fileoverview gRPC-Web generated client stub for pushwoosh.rpc_v2.events
 * @enhanceable
 * @public
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsServiceClient = void 0;
// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v3.19.1
// source: pushwoosh/events/events.proto
/* eslint-disable */
// @ts-nocheck
const grpcWeb = __importStar(require("grpc-web"));
const pushwoosh_events_events_pb = __importStar(require("../../pushwoosh/events/events_pb"));
class EventsServiceClient {
    constructor(hostname, credentials, options) {
        this.methodDescriptorGet = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.events.EventsService/Get', grpcWeb.MethodType.UNARY, pushwoosh_events_events_pb.GetEventRequest, pushwoosh_events_events_pb.Event, (request) => {
            return request.serializeBinary();
        }, pushwoosh_events_events_pb.Event.deserializeBinary);
        this.methodDescriptorList = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.events.EventsService/List', grpcWeb.MethodType.UNARY, pushwoosh_events_events_pb.ListEventsRequest, pushwoosh_events_events_pb.ListEventsResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_events_events_pb.ListEventsResponse.deserializeBinary);
        this.methodDescriptorCreate = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.events.EventsService/Create', grpcWeb.MethodType.UNARY, pushwoosh_events_events_pb.CreateEventRequest, pushwoosh_events_events_pb.CreateEventResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_events_events_pb.CreateEventResponse.deserializeBinary);
        this.methodDescriptorUpdate = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.events.EventsService/Update', grpcWeb.MethodType.UNARY, pushwoosh_events_events_pb.UpdateEventRequest, pushwoosh_events_events_pb.UpdateEventResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_events_events_pb.UpdateEventResponse.deserializeBinary);
        this.methodDescriptorDelete = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.events.EventsService/Delete', grpcWeb.MethodType.UNARY, pushwoosh_events_events_pb.DeleteEventRequest, pushwoosh_events_events_pb.DeleteEventResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_events_events_pb.DeleteEventResponse.deserializeBinary);
        this.methodDescriptorGetAttributeValues = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.events.EventsService/GetAttributeValues', grpcWeb.MethodType.UNARY, pushwoosh_events_events_pb.GetAttributeValuesRequest, pushwoosh_events_events_pb.GetAttributeValuesResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_events_events_pb.GetAttributeValuesResponse.deserializeBinary);
        this.methodDescriptorGetTriggeredCount = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.events.EventsService/GetTriggeredCount', grpcWeb.MethodType.UNARY, pushwoosh_events_events_pb.GetTriggeredCountRequest, pushwoosh_events_events_pb.GetTriggeredCountResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_events_events_pb.GetTriggeredCountResponse.deserializeBinary);
        this.methodDescriptorGetDetailedStatistics = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.events.EventsService/GetDetailedStatistics', grpcWeb.MethodType.UNARY, pushwoosh_events_events_pb.GetDetailedStatisticsRequest, pushwoosh_events_events_pb.GetDetailedStatisticsResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_events_events_pb.GetDetailedStatisticsResponse.deserializeBinary);
        this.methodDescriptorGetTotalStatistics = new grpcWeb.MethodDescriptor('/pushwoosh.rpc_v2.events.EventsService/GetTotalStatistics', grpcWeb.MethodType.UNARY, pushwoosh_events_events_pb.GetTotalStatisticsRequest, pushwoosh_events_events_pb.GetTotalStatisticsResponse, (request) => {
            return request.serializeBinary();
        }, pushwoosh_events_events_pb.GetTotalStatisticsResponse.deserializeBinary);
        if (!options)
            options = {};
        if (!credentials)
            credentials = {};
        options['format'] = 'text';
        this.client_ = new grpcWeb.GrpcWebClientBase(options);
        this.hostname_ = hostname.replace(/\/+$/, '');
        this.credentials_ = credentials;
        this.options_ = options;
    }
    get(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.events.EventsService/Get', request, metadata || {}, this.methodDescriptorGet, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.events.EventsService/Get', request, metadata || {}, this.methodDescriptorGet);
    }
    list(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.events.EventsService/List', request, metadata || {}, this.methodDescriptorList, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.events.EventsService/List', request, metadata || {}, this.methodDescriptorList);
    }
    create(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.events.EventsService/Create', request, metadata || {}, this.methodDescriptorCreate, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.events.EventsService/Create', request, metadata || {}, this.methodDescriptorCreate);
    }
    update(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.events.EventsService/Update', request, metadata || {}, this.methodDescriptorUpdate, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.events.EventsService/Update', request, metadata || {}, this.methodDescriptorUpdate);
    }
    delete(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.events.EventsService/Delete', request, metadata || {}, this.methodDescriptorDelete, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.events.EventsService/Delete', request, metadata || {}, this.methodDescriptorDelete);
    }
    getAttributeValues(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.events.EventsService/GetAttributeValues', request, metadata || {}, this.methodDescriptorGetAttributeValues, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.events.EventsService/GetAttributeValues', request, metadata || {}, this.methodDescriptorGetAttributeValues);
    }
    getTriggeredCount(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.events.EventsService/GetTriggeredCount', request, metadata || {}, this.methodDescriptorGetTriggeredCount, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.events.EventsService/GetTriggeredCount', request, metadata || {}, this.methodDescriptorGetTriggeredCount);
    }
    getDetailedStatistics(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.events.EventsService/GetDetailedStatistics', request, metadata || {}, this.methodDescriptorGetDetailedStatistics, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.events.EventsService/GetDetailedStatistics', request, metadata || {}, this.methodDescriptorGetDetailedStatistics);
    }
    getTotalStatistics(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/pushwoosh.rpc_v2.events.EventsService/GetTotalStatistics', request, metadata || {}, this.methodDescriptorGetTotalStatistics, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/pushwoosh.rpc_v2.events.EventsService/GetTotalStatistics', request, metadata || {}, this.methodDescriptorGetTotalStatistics);
    }
}
exports.EventsServiceClient = EventsServiceClient;
